class CodogotchiColourways extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll("[data-codogotchi-colour-button]"));
    this.panels = Array.from(this.querySelectorAll("[data-codogotchi-colour-panel]"));
    this.section = this.closest("#codogotchi-colourways");

    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => this.selectColour(tab));
      tab.addEventListener("keydown", (event) => this.handleKeydown(event, index));
    });

    document.querySelectorAll('a[href="#codogotchi-colourways"]').forEach((link) => {
      if (link.dataset.codogotchiScrollReady === "true") return;

      link.dataset.codogotchiScrollReady = "true";
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.section?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
        window.history.replaceState(null, "", "#codogotchi-colourways");
      });
    });
  }

  selectColour(tab) {
    const colour = tab.dataset.colour;
    const background = tab.dataset.background;

    this.style.setProperty("--codogotchi-colour-background", background);
    this.tabs.forEach((item) => {
      const isSelected = item === tab;
      item.setAttribute("aria-selected", String(isSelected));
      item.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.colour !== colour;
    });
  }

  handleKeydown(event, currentIndex) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = currentIndex;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;

    this.selectColour(this.tabs[nextIndex]);
    this.tabs[nextIndex].focus();
  }
}

if (!customElements.get("codogotchi-colourways")) {
  customElements.define("codogotchi-colourways", CodogotchiColourways);
}
